const skills = [
  "Python",
  "React",
  "AWS",
  "Django",
  "Flask",
  "Docker",
  "Kubernetes",
  "PostgreSQL",
];

export default function Skills() {
  return (
    <section className="py-20 px-6">
      <h2 className="text-3xl font-semibold text-center mb-10">Skills</h2>

      <div className="grid md:grid-cols-4 gap-6 max-w-5xl mx-auto">
        {skills.map((skill) => (
          <div
            key={skill}
            className="rounded-2xl bg-gray-900 border border-gray-800 p-6 text-center hover:scale-105 transition"
          >
            {skill}
          </div>
        ))}
      </div>
    </section>
  );
}